function updateCartItemNetPrice(item) {
  const cartItemNetPrices = item.querySelectorAll(".js-cart-item-net-price");
  if (!cartItemNetPrices || cartItemNetPrices.length === 0) {
    console.warn("No .js-cart-item-net-price found in item:", item);
    return;
  }

  const activeQtyTableRow = item.querySelector(".qty-row-active");
  if (!activeQtyTableRow) return;

  const tdFields = Object.values(activeQtyTableRow.querySelectorAll("td"));
  if (tdFields.length < 3) return;

  const priceField = tdFields.find((td) => td.textContent.includes("€"));
  const priceRaw = priceField.textContent;
  if (!priceRaw) return;

  const priceArr = priceRaw.split("€");
  const price = priceArr[0].replace(".", ",");
  if (!price) {
    console.warn("No price found after split/replace:", priceArr);
    return;
  }

  // Get the original net price for comparison
  const originalNetPriceElement = item.querySelector(
    ".js-cart-item-net-price-original",
  );
  const originalNetPrice = originalNetPriceElement?.dataset.originalNetPrice;

  // Check if this is a discounted price (lower than original)
  const isDiscounted =
    originalNetPrice &&
    parseFloat(price.replace(",", ".")) <
      parseFloat(originalNetPrice.replace("€*", "").replace(",", "."));

  // Update all net price elements (both mobile and desktop)
  cartItemNetPrices.forEach((netPriceElement) => {
    if (isDiscounted) {
      // Show discounted price as main price with original as compare price
      netPriceElement.textContent = price + " €*";
      netPriceElement.className =
        netPriceElement.className.replace(
          "text-subdued-text line-through",
          "",
        ) + " text-error";

      // Find or create compare price element for this specific net price element
      let comparePriceElement = netPriceElement.parentNode.querySelector(
        ".js-cart-item-compare-price",
      );
      if (!comparePriceElement) {
        comparePriceElement = document.createElement("span");
        comparePriceElement.className =
          "text-subdued-text line-through ml-2 js-cart-item-compare-price";

        // Check if parent is a flex-col container (desktop layout)
        const parent = netPriceElement.parentNode;
        if (parent.classList.contains("flex-col")) {
          // For desktop layout, we need to create a flex row container
          const flexRowContainer = document.createElement("div");
          flexRowContainer.className = "flex flex-row items-center";

          // Move the net price into the new container
          parent.insertBefore(flexRowContainer, netPriceElement);
          flexRowContainer.appendChild(netPriceElement);

          // Insert compare price in the same row
          flexRowContainer.appendChild(comparePriceElement);
        } else {
          // For mobile layout, insert directly after the net price
          parent.insertBefore(comparePriceElement, netPriceElement.nextSibling);
        }
      }
      comparePriceElement.textContent = originalNetPrice;
    } else {
      // Show original price normally
      netPriceElement.textContent = originalNetPrice || price + " €*";
      // Remove error styling classes more reliably
      netPriceElement.classList.remove("text-error", "text-subdued-text", "line-through");

      // Remove compare price element if it exists in this parent
      const comparePriceElement = netPriceElement.parentNode.querySelector(
        ".js-cart-item-compare-price",
      );
      if (comparePriceElement) {
        comparePriceElement.remove();

        // If we're in a flex row container (desktop layout), move the net price back to its original parent
        const parent = netPriceElement.parentNode;
        if (
          parent.classList.contains("flex") &&
          parent.classList.contains("flex-row")
        ) {
          const grandParent = parent.parentNode;
          if (grandParent && grandParent.classList.contains("flex-col")) {
            // Move net price back to the original flex-col container
            grandParent.insertBefore(netPriceElement, parent);
            // Remove the empty flex row container
            parent.remove();
          }
        }
      }
    }
  });

  // Update gross prices based on the new net price
  updateCartItemGrossPrice(item, price);

  // Dispatch event to notify cart page that item prices have changed
  document.dispatchEvent(new CustomEvent("cart:item-price-changed"));
}

function updateCartItemGrossPrice(item, netPrice) {
  const cartItemGrossPrices = item.querySelectorAll(
    ".js-cart-item-gross-price",
  );
  if (!cartItemGrossPrices || cartItemGrossPrices.length === 0) {
    console.warn("No .js-cart-item-gross-price found in item:", item);
    return;
  }

  // Convert net price to gross price (add 19% VAT)
  const netPriceFloat = parseFloat(netPrice.replace(",", "."));
  const grossPriceFloat = netPriceFloat * 1.19; // Add 19% VAT
  const grossPrice = grossPriceFloat.toFixed(2).replace(".", ",") + " €";

  // Update all gross price elements
  cartItemGrossPrices.forEach((grossPriceElement) => {
    grossPriceElement.textContent = grossPrice;
  });
}

function updateCartItemNetPriceOriginal(item) {
  const originalNetPriceText = item.querySelector(
    ".js-cart-item-net-price-original",
  );
  const originalNetPrice = originalNetPriceText.dataset.originalNetPrice;
  const priceFields = item.querySelectorAll(".js-cart-item-net-price");
  if (priceFields && priceFields.length > 0) {
    priceFields.forEach((priceField) => {
      priceField.textContent = originalNetPrice;
      // Remove error styling classes more reliably
      priceField.classList.remove("text-error", "text-subdued-text", "line-through");
    });
  }

  // Remove any compare price elements and clean up flex containers
  const comparePriceElements = item.querySelectorAll(
    ".js-cart-item-compare-price",
  );
  comparePriceElements.forEach((element) => {
    element.remove();

    // Clean up flex row containers that were created for compare prices
    const netPriceElements = item.querySelectorAll(".js-cart-item-net-price");
    netPriceElements.forEach((netPriceElement) => {
      const parent = netPriceElement.parentNode;
      if (
        parent.classList.contains("flex") &&
        parent.classList.contains("flex-row")
      ) {
        const grandParent = parent.parentNode;
        if (grandParent && grandParent.classList.contains("flex-col")) {
          // Move net price back to the original flex-col container
          grandParent.insertBefore(netPriceElement, parent);
          // Remove the empty flex row container
          parent.remove();
        }
      }
    });
  });

  // Reset gross prices to original
  const originalGrossPriceElement = item.querySelector(
    ".js-cart-item-gross-price",
  );
  if (originalGrossPriceElement && originalNetPrice) {
    // Extract original net price and convert to gross
    const originalNetPriceFloat = parseFloat(
      originalNetPrice.replace("€*", "").replace(",", "."),
    );
    const originalGrossPriceFloat = originalNetPriceFloat * 1.19;
    const originalGrossPrice =
      originalGrossPriceFloat.toFixed(2).replace(".", ",") + " €";
    originalGrossPriceElement.textContent = originalGrossPrice;
  }

  // Dispatch event to notify cart page that item prices have changed
  document.dispatchEvent(new CustomEvent("cart:item-price-changed"));
}

function observeActiveRowChange(item) {
  const qtyTable = item.querySelector(".bss-b2b-qb-table");
  if (!qtyTable) {
    return;
  }

  let lastActiveRow = item.querySelector(".qty-row-active");

  // If no active row initially, set up observer to wait for one
  if (!lastActiveRow) {
    updateCartItemNetPriceOriginal(item);
  }

  const observer = new MutationObserver(() => {
    const currentActiveRow = item.querySelector(".qty-row-active");

    // If no active row currently
    if (!currentActiveRow) {
      lastActiveRow = null;
      updateCartItemNetPriceOriginal(item);
      return;
    }

    if (currentActiveRow !== lastActiveRow) {
      lastActiveRow = currentActiveRow;
      return updateCartItemNetPrice(item);
    }
  });

  observer.observe(qtyTable, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class"],
  });

  // Initial update if we already have an active row
  if (lastActiveRow) {
    updateCartItemNetPrice(item);
  }
}

function initB2BAppPriceOverride() {
  // Check for table rows every 100ms until they exist
  const checkForRows = setInterval(() => {
    const bssQtyTableRows = document.querySelectorAll(".bss-b2b-qty-table-row");

    // Only proceed if we have rows
    if (bssQtyTableRows && bssQtyTableRows.length > 0) {
      clearInterval(checkForRows);

      bssQtyTableRows.forEach((row) => {
        const tdFields = row.querySelectorAll("td");

        if (tdFields.length < 3) return;

        const priceField = Array.from(tdFields).find((td) => td.textContent.includes("€"));
        const priceRaw = priceField.textContent;
        const priceArr = priceRaw.split("€");
        const price = priceArr[0].replace(",", ".");

        if (!price) return;

        const germanVAT = 119;
        const priceOverride = (price / germanVAT) * 100;
        priceField.textContent =
          priceOverride.toFixed(2).replace(".", ",") + " € " + priceArr[1];
      });
    }

    const cartItems = document.querySelectorAll(".js-cart-item");

    if (cartItems.length > 0) {
      cartItems.forEach((item) => {
        observeActiveRowChange(item);
      });
    }
  }, 100);

  // Clear interval after 10 seconds to prevent infinite checking
  setTimeout(() => {
    clearInterval(checkForRows);
  }, 10000);
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initB2BAppPriceOverride);
} else {
  initB2BAppPriceOverride();
}
